/* The parts product page's moving parts.

   NO VERDICT IS COMPUTED HERE. The vin-check-product app block answers "does
   this fit", reading production records, and this file puts a room around
   that answer: which trailer we are talking about, and how we checked. Two
   scripts each deciding what fits is the one failure this store cannot
   afford.

   THE HOW WE CHECKED LINE IS KEYED ON THE TRAILER, NOT THE PART. A customer
   who picked their model out of the filters never gave us a VIN, and telling
   them we checked one would be a lie told in a reassuring voice. So the copy
   branches on whether a VIN is on file, and says less when it knows less.

   ONE STEP FAILING MUST NOT TAKE THE REST WITH IT. describe() used to insert
   the Description row with box.insertBefore(row, qty), but the quantity row is
   a grandchild of that box, not a child, so the call threw. It threw inside
   start(), before paintFitment() had run and before the interval was set, so
   the trailer panel kept its Liquid placeholder ("No trailer saved yet", "Not
   identified") while the header said My Trailer 04178 and the app block beside
   it said the part fits. Each step now runs on its own, and the row goes in
   beside the quantity row inside that row's own parent.

   No requestAnimationFrame. document.hidden is true in an automation tab and
   rAF never fires there. */
(function () {
  'use strict';

  if (window.fxPdpOn) return;
  window.fxPdpOn = 1;

  function $(sel) { return document.querySelector(sel); }

  function safe(fn) {
    try { return fn(); } catch (e) {
      if (window.console && console.warn) console.warn('[fx-pdp]', fn.name || 'step', e);
      return undefined;
    }
  }

  var PHONE = '(max-width: 899px)';
  function narrow() {
    return window.matchMedia ? window.matchMedia(PHONE).matches : window.innerWidth <= 899;
  }

  var SUB = {
    vin: 'Checked against your trailer’s VIN number in Futura production records.',
    filter: 'Checked against the model and year you selected. Look yours up by VIN for an answer tied to your actual trailer.',
    none: 'Tell us your trailer and we will check this part against it.'
  };

  /* ---- the trailer, and how we know it -------------------------------- */
  function paintFitment() {
    var host = $('[data-fxp-fit]');
    if (!host) return;

    var t = window.fxTrailer ? window.fxTrailer() : null;
    var name = t ? ((t.year ? t.year + ' ' : '') + t.model) : '';

    host.setAttribute('data-fxp-has', t ? '1' : '0');
    host.setAttribute('data-fxp-by', t && t.vin ? 'vin' : (t ? 'filter' : 'none'));

    var nameNode = $('[data-fxp-name]');
    var nameWant = name || 'Not identified';
    if (nameNode && nameNode.textContent !== nameWant) nameNode.textContent = nameWant;

    var vinNode = $('[data-fxp-vin]');
    var vinWant = t && t.vin ? 'VIN ' + t.vin : (t ? 'Picked from the line-up' : '');
    if (vinNode && vinNode.textContent !== vinWant) vinNode.textContent = vinWant;

    var sub = $('[data-fxp-sub]');
    if (sub) {
      var want = !t ? SUB.none : (t.vin ? SUB.vin : SUB.filter);
      if (sub.textContent !== want) sub.textContent = want;

      /* The line belongs under the verdict and above the figures, but the
         verdict and the figures are both inside the app block, so Liquid can
         only put this after both of them. Moving it is therefore a DOM job,
         and it is redone on every pass rather than once: the block re-renders
         its own children on its own schedule, and a node placed once would
         quietly drift back down the first time it did. */
      var banner = null;
      var all = document.querySelectorAll('.fxp-fit__answer .vin-compatibility-banner');
      for (var i = 0; i < all.length; i++) {
        if (all[i].offsetHeight > 0) { banner = all[i]; break; }
      }
      if (banner && banner.nextElementSibling !== sub) banner.insertAdjacentElement('afterend', sub);

      /* On a phone the verdict leads and the trailer follows the line that
         explains it; on a wide screen the trailer goes back to the left. */
      var trailer = host.querySelector('.fxp-fit__trailer');
      var answer = host.querySelector('.fxp-fit__answer');
      if (trailer && answer) {
        if (narrow()) {
          if (sub.nextElementSibling !== trailer) sub.insertAdjacentElement('afterend', trailer);
        } else if (host.firstElementChild !== trailer) {
          host.insertBefore(trailer, host.firstElementChild);
        }
      }
    }

    /* The same render file the line-up and the drawer use, so the trailer on
       this page is recognisably the one they picked. */
    var well = $('[data-fxp-render]');
    if (!well || !window.fxRenderFor) return;
    var url = t ? (window.fxRenderFor(t.model) || '') : '';
    var key = t ? url || ('none:' + name) : 'none';
    if (well.getAttribute('data-src') === key) return;
    well.setAttribute('data-src', key);
    well.textContent = '';

    if (!url) {
      var p = document.createElement('p');
      p.className = 'fxp-fit__none';
      p.textContent = t ? name : 'No trailer saved yet';
      well.appendChild(p);
      return;
    }
    if (window.fxLenFor) well.style.setProperty('--fx-len', String(window.fxLenFor(t.model) || 1));
    var im = document.createElement('img');
    im.src = url;
    im.alt = '';
    im.decoding = 'async';
    well.appendChild(im);
  }

  /* ---- the way back --------------------------------------------------- */
  function back() {
    var a = $('[data-fxp-back]');
    var label = $('[data-fxp-back-label]');
    if (!a || !label) return;

    var ref = document.referrer || '';
    var here = window.location.origin;
    if (ref.indexOf(here) !== 0) return;         /* keep the href and the label */

    var path = ref.slice(here.length).split('?')[0];
    label.textContent = (path === '' || path === '/') ? 'Back to your parts' : 'Back';
    a.setAttribute('href', ref);
    a.addEventListener('click', function (e) {
      if (window.history.length > 1) { e.preventDefault(); window.history.back(); }
    });
  }

  /* ---- the sticky bar -------------------------------------------------
     It arrives once the real Add to cart has scrolled away and leaves when it
     comes back, so there are never two of the same button on screen. */
  function stickyBar() {
    var add = $('.product-form__submit');
    if (!add || !window.IntersectionObserver) return;

    var bar = document.createElement('div');
    bar.className = 'fxp-bar';
    bar.innerHTML =
      '<span class="fxp-bar__t"></span>' +
      '<span class="fxp-bar__p"></span>' +
      '<button type="button" class="fxp-bar__go"></button>';
    document.body.appendChild(bar);

    var title = $('.product__title h1');
    var price = $('.product__info-container .price .price-item--last') ||
                $('.product__info-container .price .price-item');
    bar.querySelector('.fxp-bar__t').textContent = title ? title.textContent.trim() : '';
    bar.querySelector('.fxp-bar__p').textContent = price ? price.textContent.trim() : '';

    var go = bar.querySelector('.fxp-bar__go');
    function label() {
      var txt = (add.textContent || '').replace(/\s+/g, ' ').trim();
      if (go.textContent !== txt) go.textContent = txt;
      if (go.disabled !== !!add.disabled) go.disabled = !!add.disabled;
    }
    label();
    go.addEventListener('click', function () { add.click(); });

    new IntersectionObserver(function (e) {
      bar.classList.toggle('is-up', !e[0].isIntersecting);
    }, { rootMargin: '-72px 0px 0px 0px' }).observe(add);

    setInterval(label, 900);
  }

  /* ---- the description, in the buy column ------------------------------
     It wraps the theme's own description node rather than printing the text a
     second time.

     WHERE IT GOES, AND WHY IT MOVED (27 Sep). The old code took
     .vin-fx-buy-row OR .product-form as its anchor. On a phone the buy row is
     often not built yet on the first pass, so it fell through to
     .product-form, which lives INSIDE the buy row's right hand column next to
     the quantity stepper. The row then rendered about 128px wide, above Add
     to cart. It now waits for the buy row rather than falling back, and it is
     repositioned on every pass instead of only being built once, because the
     buy row can be rebuilt underneath it.

     On a phone it sits after the fit check line, under Add to cart, where it
     runs the full width of the column. On a wide screen it stays above the
     quantity row, as it always has. */
  function describe() {
    var box = $('.product__info-container');
    if (!box) return;

    var buyRow = box.querySelector('.vin-fx-buy-row');
    if (!buyRow) return;                       /* the 900ms poll comes back */

    var row = box.querySelector('.fxp-buy-det');

    if (!row) {
      var desc = box.querySelector('.product__description');
      if (!desc || !desc.textContent.trim()) return;

      row = document.createElement('details');
      row.className = 'fxp-det__row fxp-buy-det';
      row.open = true;
      row.innerHTML =
        '<summary class="fxp-det__h"><span>Description</span>' +
        '<svg class="fxp-det__chev" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">' +
        '<path d="M3.6 6 L8 10.4 L12.4 6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg></summary><div class="fxp-det__b"></div>';

      buyRow.parentNode.insertBefore(row, buyRow);
      row.querySelector('.fxp-det__b').appendChild(desc);
    }

    /* Reposition every pass. Cheap when it is already right. */
    if (narrow()) {
      var after = box.querySelector('.vin-check-fitcheck-row') || buyRow;
      if (after.nextElementSibling !== row) {
        after.parentNode.insertBefore(row, after.nextSibling);
      }
    } else if (row.nextElementSibling !== buyRow) {
      buyRow.parentNode.insertBefore(row, buyRow);
    }
  }

  /* ---- keeping ExpertRec off the parts search --------------------------
     ExpertRec claims any input that looks like a search box and stamps it
     data-er-attached. Stamping it ourselves first makes it skip the field.
     THIS IS A PATCH, NOT THE FIX: the extension should rename that input. */
  function fence() {
    var box = document.getElementById('vcpMoreParts') || document.querySelector('.vcp-more');
    if (!box) return false;
    var inputs = box.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (!el.getAttribute('data-er-attached')) el.setAttribute('data-er-attached', 'true');
      if (el.name && el.name.indexOf('search') > -1) el.name = 'fxq-parts';
    }
    return inputs.length > 0;
  }

  function start() {
    safe(paintFitment);
    safe(back);
    safe(stickyBar);
    safe(describe);
    /* My Trailer is a site wide drawer and it has never heard of this page. A
       slow poll is cheaper than wiring an event through four scripts. */
    setInterval(function () { safe(describe); safe(paintFitment); safe(fence); }, 900);

    var tries = 0;
    var watch = setInterval(function () {
      if (safe(fence) || ++tries > 60) clearInterval(watch);
    }, 150);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else setTimeout(start, 0);
})();